import { render } from "./AppInfo.vue?vue&type=template&id=f12bf364&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"

import "./AppInfo.vue?vue&type=style&index=0&id=f12bf364&scoped=true&lang=css"

import exportComponent from "F:\\svn\\cdbwsoft\\mxs-download\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12bf364"]])

export default __exports__